import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HrccService } from '../services/hrcc.service';
import { SickLeaveListService } from '../services/sick-leave-list.service';
import { CommonService } from '../services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-hrcc-view',
  templateUrl: './hrcc-view.component.html',
  styleUrls: ['./hrcc-view.component.css'],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
            state('rotated90', style({ transform: 'rotate(90deg)' })),
            state('rotated180', style({ transform: 'rotate(180deg)' })),
            state('rotated270', style({ transform: 'rotate(270deg)' })),
            state('rotated360', style({ transform: 'rotate(360deg)' })),
            transition('default => rotated90', animate('200ms ease-out')),
            transition('rotated90 => rotated180', animate('200ms ease-out')),
            transition('rotated180 => rotated270', animate('200ms ease-out')),
            transition('rotated270 => rotated360', animate('200ms ease-out')),
            
  ])
]
})
export class HrccViewComponent implements OnInit {

  public doThisForAll: boolean;
  public certificateData;
  public correctionFormEnableFlag: boolean;
  public successFlag: boolean;
  public successMsg: string;

  public sickLeave;
  public sickLeave_fake = {
    "absenceid": null,
    "revisionkey": null,
    "empid": null,
    "allocatedtoexpert": null,
    "expertname": null,
    "allocatedtohradmin": null,
    "hrname": null,
    "statusabsenceexpert": null,
    "statusabsenceexpert_desc": null,
    "statushradmin": 2,
    "statushradmin_desc": null,
    "illnesstype": null,
    "recordcreateddate": null,
    "datesmismatch": true,
    "isreasonverified": true,
    "potentialphotocopy": false,
    "signatureseenbefore": false,
    "doctorsseen": 2,
    "sameasrejectedholiday": false,
    "coincideswithmajorevnt": false,
    "signaturedectected": true,
    "csvgenerated": null,
    "ocrcertdate": null,
    "ocrstartdate": null,
    "ocrenddate": null,
    "noocr_date": null,
    "nocertificate": null,
    "issuetype": ""
  }

  public dataObject;
  public dataObject_fake = {
    "employeeId": "N/A",
    "prefdLang": "N/A",
    "absenceInfo": {
      "txnID": "N/A",
      "absenceID": "N/A",
      "typeOfLeave": "N/A",
      "leavePin": "N/A",
      "leaveSubmittedOn": null,
      "fromDate": '',
      "toDate": '',
      "certificateInfo": {
        "certificateAttached": "N",
        "certificateAddedOn": null,
        "certificateRefID": "N/A",
        "certificateURI": "N/A"
      },
      "addressDuringSickness": {
        "addressType": "N/A",
        "address": {
          "streetName": "N/A",
          "streetNumber": "N/A",
          "boxNo": "N/A",
          "city": "N/A",
          "postalCode": "N/A",
          "country": "N/A"
        }
      }
    }
  };
  public employeeObject;
  public employeeObject_fake = {
    "firstName": "N/A",
    "lastName": "N/A",
    "username": "N/A",
    "emailID": "N/A",
    "empID": "N/A",
    "prefdLang": "fr",
    "empType": "N/A",
    "contactNumber": "N/A",
    "contactNumPersonal": "N/A",
    "addressInfo": {
      "addressType": "N/A",
      "address": {
        "streetName": "N/A",
        "streetNumber": "N/A",
        "boxNo": "N/A",
        "city": "N/A",
        "postalCode": "N/A",
        "country": "N/A"
      }
    },
    "managerInfo": {
      "firstName": "N/A",
      "lastName": "N/A",
      "contactNumber": "N/A",
      "emailID": "N/A",
      "empID": "N/A"
    }
  };

  public linkedIllnessFlag: boolean;
  public linkedIllness: any = [
    {
      "absenceID": "201712051076330",
      "certificateID": "8841e772-c160-437f-b226-22c5e560f1df",
      "appstartdate": "2018-10-10T22:00:00.000Z",
      "appenddate": "2018-10-17T22:00:00.000Z",
      "status": "Justified"
    },
    {
      "absenceID": "201712051076330",
      "certificateID": "8841e772-c160-437f-b226-22c5e560f1df",
      "appstartdate": "2018-10-10T22:00:00.000Z",
      "appenddate": "2018-10-17T22:00:00.000Z",
      "status": "Justified"
    },
    {
      "absenceID": "201712051076330",
      "certificateID": "8841e772-c160-437f-b226-22c5e560f1df",
      "appstartdate": "2018-10-10T22:00:00.000Z",
      "appenddate": "2018-10-17T22:00:00.000Z",
      "status": "Justified"
    },
    {
      "absenceID": "201712051076330",
      "certificateID": "8841e772-c160-437f-b226-22c5e560f1df",
      "appstartdate": "2018-10-10T22:00:00.000Z",
      "appenddate": "2018-10-17T22:00:00.000Z",
      "status": "Justified"
    }
  ];

  public rotateDegree = 0;
  public rotateDegreeString = '0';
  
  public absenceId: string;
  public certificateID: string;
  public empDetailsFlag: boolean;
  public absenceDetailsFlag: boolean;
  public absenceDetailsPostgreFlag: boolean;
  public certificateFlag: boolean;
  public certificateError: string;

  constructor(public commonService: CommonService,
    private _sanitizer: DomSanitizer,
    public sickLeaveService: SickLeaveListService,
    public hrccService: HrccService,
    public router: Router,
    public activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.doThisForAll = false;
    this.absenceId = '';
    this.certificateID = '';
    this.linkedIllness = [];
    this.linkedIllnessFlag = false;
    this.empDetailsFlag = false;
    this.absenceDetailsFlag = false;
    this.absenceDetailsPostgreFlag = false;
    this.absenceId = this.activatedRoute.snapshot.paramMap.get('absenceId');
    let employeeId = this.activatedRoute.snapshot.paramMap.get('employeeId');
    // this.sickLeave = JSON.parse(localStorage.getItem('obj'));
    this.correctionFormEnableFlag = false;
    this.successFlag = false;

    this.getIrregularityByAbsenceId(this.absenceId, employeeId);
    this.getEmployeeByEmployeeId(employeeId);
    this.getIrregularityByAbsenceIdFromPostgre(this.absenceId);
  }

  getLinkedLeaves(certificateID, absenceID) {
    this.linkedIllness = [];
    this.hrccService.getLinkedLeaves(certificateID, absenceID)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.linkedIllness = res.response.absences;
            this.linkedIllnessFlag = true;
          } else {
            this.linkedIllness = [];
            this.linkedIllnessFlag = false;
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.linkedIllness = [];
          this.linkedIllnessFlag = false;
        });
  }

  getIrregularityByAbsenceIdFromPostgre(absenceID) {
    this.commonService.getIrregularityByAbsenceId(absenceID)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.sickLeave = res.response;
            this.absenceDetailsPostgreFlag = true;
          } else {
            this.absenceDetailsPostgreFlag = true;
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.sickLeave = this.sickLeave_fake;
          this.absenceDetailsPostgreFlag = true;
        }
      );
  }

  getIssuesIntoArray(list) {
    let tempArray = [];
    let splitedArray = list.split(';');
    for (let i = 0; i < splitedArray.length; i++) {
      if (splitedArray[i].trim() !== '') {
        tempArray.push(splitedArray[i]);
      }
    }
    return tempArray;
  }

  getIrregularityByAbsenceId(absenceId, employeeId) {
    this.hrccService.getIrregularityByAbsenceId(absenceId, employeeId)
      .subscribe(
        (res: any) => {
          this.absenceDetailsFlag = res.status === 'success' ? true : false;
          if (this.absenceDetailsFlag === true) {
            console.log(res);
            this.dataObject = res.response;
            if (this.dataObject.absenceInfo.certificateInfo.certificateAttached === 'Y') {
              this.getCertificate(this.dataObject.absenceInfo.certificateInfo.certificateRefID);
              this.certificateID = this.dataObject.absenceInfo.certificateInfo.certificateRefID;
              this.getLinkedLeaves(this.certificateID, this.absenceId);
            }
          } else {
            this.dataObject = this.dataObject_fake;
            this.absenceDetailsFlag = true;
            alert('Not able to get the absence information!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.dataObject = this.dataObject_fake;
          this.absenceDetailsFlag = true;
          alert('Not able to get the absence information!');
        }
      );
  }

  getEmployeeByEmployeeId(employeeId) {
    this.hrccService.getEmployeeByEmployeeId(employeeId)
      .subscribe(
        (res: any) => {
          this.empDetailsFlag = res.status === 'success' ? true : false;
          if (this.empDetailsFlag === true) {
            this.employeeObject = res.response.emp;
          } else {
            this.employeeObject = this.employeeObject_fake;
            this.empDetailsFlag = true;
            alert('Not able to get the employee information!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.employeeObject = this.employeeObject_fake;
          this.empDetailsFlag = true;
          alert('Not able to get the employee information!');
        });
  }

  getCertificate(certificateId) {
    this.certificateFlag = false;
    this.certificateError = '';
    this.commonService.getCertificate(certificateId)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.certificateFlag = false;
            this.certificateData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + res.response.base64image);
          } else {
            this.certificateFlag = true;
          }
        }, (err) => {

          this.certificateFlag = true;
        })
  }

  closeCorrectionForm(closeCorrectionView: any) {
    this.successFlag = false;
    this.correctionFormEnableFlag = !closeCorrectionView.closeFlag;
    this.getIrregularityByAbsenceIdFromPostgre(this.sickLeave.absenceid);
    // if (closeCorrectionView.closeMsg === 'submit') {
    //   this.successFlag = true;
    //   this.successMsg = 'Correction successful!';
    // }
  }

  openCorrectionForm() {
    this.correctionFormEnableFlag = true;
  }

  changeStauts(data) {
    let ids = [];
    let temp = {
      'absenceid': this.sickLeave.absenceid,
      'revisionkey': this.sickLeave.revisionkey,
      'statusabsencehradmin': data
    }
    ids.push(temp);
    if (this.doThisForAll === true) {
      if (this.linkedIllness.length !== 0) {
        for (let i = 0; i < this.linkedIllness.length; i++) {
          let temp_inner = {
            'absenceid': '',
            'revisionkey': '',
            'statusabsencehradmin': 0
          }
          temp_inner = {
            'absenceid': this.linkedIllness[i].absenceID,
            'revisionkey': this.linkedIllness[i].revisionKey,
            'statusabsencehradmin': data
          }
          ids.push(temp_inner);
        }
      }
    }

    this.sickLeaveService.updateHrExpertAllocation(ids, [], sessionStorage.getItem('user'))
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            alert('Leave status changed for Absence ID ' + this.sickLeave.absenceid);
            // this.router.navigate(['/sll']);
            this.getIrregularityByAbsenceIdFromPostgre(this.sickLeave.absenceid);
            this.getLinkedLeaves(this.certificateID, this.absenceId);
          } else {
            if (res.status === 'fail') {
              alert('Error while updating the status!');
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
        }
      );



  }

  state: string = 'default';

    rotate() {
        //this.state = (this.state === 'default' ? 'rotated' : 'default');
        if(this.state === 'default'){
          this.state = 'rotated90'
        }else if(this.state === 'rotated90'){
           this.state = 'rotated180'
        }else if(this.state === 'rotated180'){
           this.state = 'rotated270'
        }else if(this.state === 'rotated270'){
           this.state = 'rotated360'
           this.state = 'default'
        }else{
          this.state = 'default'
        }
    }
  
    rotateStyle: string;
    rotateImage() {
      this.rotateStyle = 'rotate';
      this.rotateDegree += 90;
      if (this.rotateDegree === 360) {
        this.rotateDegree = 0;
      }
      this.rotateDegreeString = this.rotateDegree.toString();
      console.log( this.rotateDegreeString);
    }

}



// WEBPACK FOOTER //
// ./src/app/hrcc-view/hrcc-view.component.ts